import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface ClockProps {
	city: string;
	timeZone: string;
	isDark: boolean;
}

const Clock: React.FC<ClockProps> = ({ city, timeZone, isDark }) => {
	const [time, setTime] = useState(
		new Date().toLocaleTimeString('en-US', { timeZone, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
	);

	useEffect(() => {
		const timer = setInterval(() => {
			setTime(new Date().toLocaleTimeString('en-US', { timeZone, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }));
		}, 1000);
		return () => clearInterval(timer);
	}, [timeZone]);

	return (
		<div className={`flex flex-col min-w-[64px] px-2 py-1 border-r ${isDark ? 'border-[#222]' : 'border-neutral-200'} last:border-r-0`}>
			<span className={`text-[8px] uppercase tracking-widest font-mono mb-0.5 ${isDark ? 'text-neutral-500' : 'text-neutral-400'}`}>{city}</span>
			<span className={`text-[11px] font-mono font-medium tracking-tight ${isDark ? 'text-neutral-200' : 'text-neutral-800'}`}>{time}</span>
		</div>
	);
};

interface DashboardHeaderProps {
	isDark: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ isDark }) => {
	const { user } = useAuth();

	return (
		<div className="flex items-center justify-between w-full h-full gap-2 lg:gap-4 overflow-hidden">
			{/* The clocks container */}
			<div className={`flex items-center overflow-x-auto rounded-none border ${isDark ? 'border-[#333] bg-[#0a0a0a]' : 'border-neutral-200 bg-white'} ml-auto w-full md:w-auto`}>
				{/* Style to hide scrollbar but maintain functionality */}
				<style>{`
					.overflow-x-auto::-webkit-scrollbar { display: none; }
					.overflow-x-auto { -ms-overflow-style: none; scrollbar-width: none; }
				`}</style>
				<Clock city="Ankara" timeZone="Europe/Istanbul" isDark={isDark} />
				<Clock city="Washington" timeZone="America/New_York" isDark={isDark} />
				<Clock city="London" timeZone="Europe/London" isDark={isDark} />
				<Clock city="Paris" timeZone="Europe/Paris" isDark={isDark} />
				<Clock city="Vatican" timeZone="Europe/Vatican" isDark={isDark} />
			</div>
		</div>
	);
};

export default DashboardHeader;
